import React from 'react';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import './account-branding.css';

function AccountBranding() {
    let breadCrumbsData = [
        { title: 'Dashboard', path: '/Overview', isActive: true },
        { title: 'Admin', path: '', isActive: true },
        { title: 'AccountBranding', path: '/admin/accountbranding', isActive: false },
    ];

    return (
        <div className="col-md-10 offset-md-2 content-card">
            <BreadCrumbs data={breadCrumbsData} />
            <div className="admin-panel-bg p-3">
                <div className="row">
                    <div className="col-md-11">
                        <h5 className="font-18 tt-bold acc-mgmt-header">Account Branding</h5>
                        <p className="font-13 regular-text acc-mgmt-subcolor mb-5">
                        Account branding is a feature used to customize the logo and the theme of the application. It will be reflected in all the modules across the application.
                        </p>
                    </div>
                </div>
                <label className="bold-text  w-100 font-15 mb-3 acc-mgmt-header">Account Logo</label>
                <img src="/Images/hivelogo.svg" alt="hive-img" className="mb-3" />
                <button type="button" disabled className="btn hive-btn-outline px-3 d-block font-12 semibold-text mb-1">
                    Replace Logo
                </button>
                <label className="font-13 regular-text acc-mgmt-subcolor mb-5">
                    File must be less than 250 KB and in JPG, PNG, or SVG format
                </label>
                <label className="bold-text w-100 font-15 mb-2 acc-mgmt-header">Theme Settings</label>
                <p className="font-13 regular-text acc-mgmt-subcolor mb-2">Choose a color to customize your user interface</p>
                <div className="row">
                    <div className="col-md-6">
                        <div className="admin-brand-customize p-3 rounded-3">
                            <div className="color-picker-head acc-mgmt-borderbottom pb-3">
                                <div className="w-100 d-flex ">
                                    <div className="input-group color-picker-group border border-2 p-2 rounded-3">
                                        <input type="color" name="color" className="admin-custom-color-picker me-2" />
                                        <label className="font-11 semibold-text pt-1 border-2 border-start px-2">#000000</label>
                                    </div>
                                    <div className="pt-2 ms-3">
                                        <a className="font-12 text-decoration-none semibold-text font-orange ">
                                            <img src="/Images/color-reset.svg" className="me-1" alt="reset-icon" />
                                            Reset to default
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="pt-3 d-flex justify-content-between align-items-center">
                                <label htmlFor="tint-switch" className="w-100">
                                    <p className="mb-1 font-12 acc-mgmt-header semibold-text w-100">
                                        Apply relevant changes to the background
                                    </p>
                                    <p className="mb-0 font-12 acc-mgmt-subcolor regular-text w-100">
                                        Tint of your selected color will replace the background color
                                    </p>
                                </label>
                                <div className="form-check form-switch">
                                    <input disabled className="form-check-input branding-toggle" type="checkbox" id="tint-switch" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 my-5 justify-content-between d-flex">
                        <button type="button" className="btn hive-btn-secondary bold-text"></button>
                        <button type="button" disabled className="btn hive-btn-primary">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AccountBranding;
